
































































import { Select, Option } from 'element-ui'
import { Component, Vue } from 'vue-property-decorator'
import { Route } from 'vue-router'

import CustomerNotificationListItem from '@/components/CustomerNotificationListItem.vue'
import GoBackButton from '@/components/GoBackButton.vue'

import Booking from '@/models/booking'
import Customer from '@/models/customer'
import CustomerNotification, {
  NOTIFICATION_PAGE_PER_PAGE_NOTIFICATIONS_AMOUNT,
} from '@/models/customer-notification'

import dayjs from '@/dayjs'
import store from '@/store'
import { BookingsActionTypes } from '@/store/modules/bookings'
import {
  CustomerNotificationsActionTypes,
  CustomerNotificationsGetters,
  CustomerNotificationsMutationTypes,
} from '@/store/modules/customerNotifications'
import { UtilityGetters } from '@/store/modules/utility'

@Component({
  components: {
    CustomerNotificationListItem,
    GoBackButton,
    [Select.name]: Select,
    [Option.name]: Option,
  },
})
export default class NotificationsPage extends Vue {
  notificationPerPageAmount = NOTIFICATION_PAGE_PER_PAGE_NOTIFICATIONS_AMOUNT
  page = 1

  beforeRouteEnter(to: Route, from: Route, next: (to?: Location) => void) {
    store.dispatch(CustomerNotificationsActionTypes.Load, { page: 1 })
    store.dispatch(BookingsActionTypes.Load)
    next()
  }

  get notifications(): CustomerNotification[] {
    if (this.bookingId) {
      return this.$store.getters[
        CustomerNotificationsGetters.CustomerNotificationsByBookingId
      ](this.bookingId)
    } else {
      return this.$store.getters[
        CustomerNotificationsGetters.CustomerNotifications
      ]
    }
  }

  get hasMore() {
    return this.$store.getters[CustomerNotificationsGetters.HasMore]
  }

  get currentCustomer(): Customer {
    return this.$store.getters.getCurrentCustomer
  }

  get bookingId(): number {
    return this.$store.state.customerNotifications.bookingId
  }

  get notificationGroupedByDay(): { [key: string]: CustomerNotification[] } {
    const sortedByDay = this.$_.orderBy(this.notifications, 'createdAt', 'desc')

    return this.$_.groupBy(sortedByDay, (notification: CustomerNotification) =>
      dayjs(notification.createdAt).startOf('day').format(),
    )
  }

  get bookingIds() {
    if (!this.bookings) {
      return []
    }

    const bookingIds = this.bookings.map((a) => a.id)
    return bookingIds.sort((a, b) => (a > b ? -1 : 1))
  }

  get bookings(): Booking[] {
    return this.$store.getters.getBookings
  }

  get isMobileScreen(): string {
    return this.$store.getters[UtilityGetters.IsMobileScreen]
  }

  chosenBookingLabel(bookingId: number | null): string {
    if (bookingId === null) {
      return 'All Bookings'
    }

    return `Booking #${bookingId}`
  }

  onBookingIdChange(bookingId: number) {
    this.page = 1
    this.$store.commit(
      CustomerNotificationsMutationTypes.ChangeBookingId,
      bookingId,
    )
    this.$store.dispatch(CustomerNotificationsActionTypes.Load, {
      page: this.page,
      bookingId,
    })
  }

  showMoreNotifications() {
    this.page += 1
    const { page, bookingId } = this

    this.$store.dispatch(CustomerNotificationsActionTypes.Load, {
      page,
      bookingId,
    })
  }
}
